/**
 * Fiche sur grand écran : contenu principal et colonne de contexte (client,
 * site, contacts, montants). Au téléphone, la colonne passe sous le contenu.
 */
import type { ReactNode } from 'react';

export function DetailLayout(props: {
  main: ReactNode;
  aside?: ReactNode;
  asideLabel?: string;
  /** Deux colonnes égales dès 900 px, sans colonne collante (accueil du portail client). */
  balanced?: boolean;
}): ReactNode {
  if (!props.aside) return <div className="ui-detail">{props.main}</div>;
  return (
    <div className={`ui-detail ui-detail--with-aside${props.balanced ? ' ui-detail--balanced' : ''}`}>
      <div className="ui-detail__main">{props.main}</div>
      <aside className="ui-detail__aside" aria-label={props.asideLabel ?? 'Contexte'}>
        {props.aside}
      </aside>
    </div>
  );
}
